// @flow

import ko from 'rgs-knockout';
import contractSelectTemplate from './contract-select-template.html';

export * from './contract-select';

ko.components.register('app-my-accident-insurance-contract-select', {
	template: contractSelectTemplate(),
});
